import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../routes/routes";
import { ViewModelContainer } from "../../viewmodel/viewmodel";
export const UserIdView = observer(() => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const inputRef = useRef(null);
    const [userId, setUserId] = useState("");
    const [placeholder, setPlaceholder] = useState(t("user.userid"));
    const handleNavigation = (route) => {
        if (!userId.trim()) {
            inputRef.current?.focus();
            setPlaceholder(t("user.userid-invalid"));
            return;
        }
        ViewModelContainer.resetContainerWithUserId(userId);
        navigate(route);
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleNavigation(AppRoutes.Registrations);
        }
    };
    return (_jsx("div", { className: "d-flex justify-content-center align-items-center", children: _jsxs("div", { className: "card mt-5 w-50", children: [_jsx("h6", { className: "card-header pt-2 pb-2", children: t("welcome") }), _jsxs("div", { className: "card-body", children: [_jsx("h6", { className: "card-title mb-3", children: t("user.startBy") }), _jsx("div", { className: "card-text", children: _jsx("div", { className: "input-group input-group-md", children: _jsx("input", { type: "text", className: "form-control", placeholder: placeholder, value: userId, ref: inputRef, onChange: (e) => setUserId(e.target.value), onKeyDown: handleKeyDown, style: { maxWidth: "50em" }, autoFocus: true, "aria-label": placeholder, "aria-describedby": "inputGroup-sizing-md" }) }) }), _jsxs("div", { className: "d-flex justify-content-end mt-3", children: [_jsx("button", { type: "button", className: "btn btn-primary btn-sm me-2", onClick: () => handleNavigation(AppRoutes.Registrations), disabled: !userId.trim(), children: t("user.showRegistrations") }), _jsx("button", { type: "button", className: "btn btn-secondary btn-sm", onClick: () => handleNavigation(AppRoutes.Operations), disabled: !userId.trim(), children: t("user.showOperations") })] })] })] }) }));
});
